var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSpeakerSlash = function SvgIconSpeakerSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.25 3a1 1 0 0 0-1.615-.789l-3.14 2.447a1 1 0 1 0 1.229 1.578l1.526-1.19v3.85a1 1 0 1 0 2 0zm-10.01.077a1 1 0 0 0-1.48 1.346L6.33 7.25H3A1.75 1.75 0 0 0 1.25 9v6A1.75 1.75 0 0 0 3 16.75h4.157l6.48 5.04A1 1 0 0 0 15.25 21v-3.938l3.51 3.86a1 1 0 1 0 1.48-1.345zM3.25 9.25H6.5v5.5H3.25zm10 9.705L8.5 15.261V9.637l4.75 5.225zm3.91-9.78a1 1 0 0 1 1.414-.003 3.99 3.99 0 0 1 .688 4.742 1 1 0 0 1-1.755-.959 1.99 1.99 0 0 0-.343-2.365 1 1 0 0 1-.004-1.414m4.068-2.655a1 1 0 0 0-1.413 1.416 5.74 5.74 0 0 1 .375 7.713 1 1 0 1 0 1.544 1.271 7.74 7.74 0 0 0-.506-10.4",
    clipRule: "evenodd"
  })));
};
export default SvgIconSpeakerSlash;